// What on the orders page needs a person (« À vérifier »), from what the
// page already reads: GET /api/commerce/orders/stats (problem_open,
// parcel_monitoring), GET /api/commerce/webhooks (consecutive_failures,
// status) and GET /api/shops (orders_sync.last_error, needs_authorization).
// Pure: the page renders the words. Tested in CommerceOrders.test.js.

export const hostOf = (url) => {
    try {
        return new URL(url).host;
    } catch (e) {
        return url || '';
    }
};

export const commerceAttention = ({ stats, webhooks, shops }) => {
    const items = [];
    if (stats && Number(stats.problem_open) > 0) {
        items.push({ key: 'problems', tone: 'danger', count: Number(stats.problem_open) });
    }
    if (stats && !stats.parcel_monitoring?.enabled && Number(stats.total) > 0) {
        items.push({ key: 'monitoringOff', tone: 'warning', total: Number(stats.total) });
    }
    (webhooks || []).forEach((endpoint) => {
        if (endpoint.status === 'disabled') return;
        if (Number(endpoint.consecutive_failures) > 0) {
            items.push({ key: `webhook-failing-${endpoint.id}`, kind: 'webhookFailing', tone: 'danger', host: hostOf(endpoint.url), failures: Number(endpoint.consecutive_failures), error: endpoint.last_delivery?.error || null });
        } else if (endpoint.status === 'pending_verification') {
            items.push({ key: `webhook-pending-${endpoint.id}`, kind: 'webhookPending', tone: 'warning', host: hostOf(endpoint.url) });
        }
    });
    (shops || []).forEach((shop) => {
        if (!shop.uses?.orders || !shop.enabled) return;
        if (shop.platform === 'shopify' && !shop.installed) {
            items.push({ key: `shop-install-${shop.id}`, kind: 'shopInstall', tone: 'warning', name: shop.name });
        } else if (shop.orders_sync?.last_error) {
            items.push({ key: `shop-import-${shop.id}`, kind: 'shopImport', tone: 'danger', name: shop.name, error: shop.orders_sync.last_error });
        }
    });
    // Blocking first, then what to watch.
    return items.map((item) => ({ kind: item.kind || item.key, ...item }))
        .sort((a, b) => (a.tone === b.tone ? 0 : a.tone === 'danger' ? -1 : 1));
};

// Badge tones of the shared vocabulary in api.js (STATUS_TONE / PARCEL_TONE).
export const badgeTone = (tone) => ({ muted: undefined, blue: 'info', accent: 'accent', success: 'success', danger: 'danger', warning: 'warning' }[tone]);

// French defaults of the source names (the locale holds them as commerceOrders.sources.*).
export const SOURCE_LABEL = { shopify: 'Shopify', prestashop: 'PrestaShop', api: 'API' };
